import axios from "axios";
import { useRouter } from "next/router";
import Head from "next/head";
import BlogLayout from "../../../components/blog_layout";
import BlogPreview from "../../../components/blog/blog_preview/blog_preview";
import styles from "./category.module.scss";
import { capitalizeFirstLetter } from "../../../utils/capitalizeFirstLetter";
import getCommonLocales from "../../../locales/locales_common";

export default function Category({ data }) {
	const { locale, query } = useRouter();
	const dictionary = getCommonLocales(locale);
	const blogs = [];
	const categories = [];
	let seo_info = {};
	let categoryDescription;

	data.filter((item) => {
		if (item.attributes.category.data?.attributes.name.toLowerCase() === query.category) {
			// get head data
			seo_info.title = item.attributes.category.data.attributes.seo_title;
			seo_info.description = item.attributes.category.data.attributes.seo_description;
			// fing blogs and categories
			categoryDescription = item.attributes.category.data.attributes.description;

			blogs.push(item);
		}
		categories.indexOf(item.attributes.category.data?.attributes.name.toLowerCase()) === -1 && categories.push(item.attributes.category.data?.attributes.name.toLowerCase());
	});

	return (
		<BlogLayout mainClassName="blog" categories={categories}>
			<Head>
				<title>{seo_info.title}</title>
				<meta name="description" content={seo_info.description} />
				<link rel="canonical" href={`https://bgrem.ai/blog/categories/${query.category.replace(" ", "%20")}/`} />
			</Head>
			<section className={styles.hero}>
				<div className={styles["title-block"]}>
					<h1 className={styles.title}>{dictionary[capitalizeFirstLetter(query.category)]?.toUpperCase() || dictionary["Tips&Ideas"]?.toUpperCase() || query.category.toUpperCase()}</h1>
					{categoryDescription && <p className={styles.description}>{categoryDescription}</p>}
				</div>
			</section>
			<section className={styles.container}>
				{blogs.map((item) => {
					return (
						<div key={item.id} className={styles.child}>
							<BlogPreview cardData={item} className="small" />
						</div>
					);
				})}
			</section>
		</BlogLayout>
	);
}

export async function getServerSideProps(context) {
	let category = context.query.category;
	category = category[0].toUpperCase() + category.substring(1);
	const date = new Date().toISOString().slice(0, 10);
	const { data } = await axios.get(`https://cms.bgrem.ai/api/blogs?populate=*&filters[date][$lte]=${date}&sort=date%3Adesc`);
	return { props: { ...data } };
}
